'use client';

import styled from 'styled-components';

import type { SpacingType } from '../../css/spacing';
import { spacingHelper } from '../../css/spacingOld';
import { Breakpoints, ContainerMaxWidth } from '../../theme/breakpoints';

type Props = {
  spacing?: SpacingType;
};

export const Container = styled.div<Props>`
  ${({ spacing }) => spacing && spacingHelper(spacing)};
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${Breakpoints.sm}) {
    & {
      max-width: ${ContainerMaxWidth.sm};
    }
  }
  @media (min-width: ${Breakpoints.md}) {
    & {
      max-width: ${ContainerMaxWidth.md};
    }
  }
  @media (min-width: ${Breakpoints.lg}) {
    & {
      max-width: ${ContainerMaxWidth.lg};
    }
  }
  @media (min-width: ${Breakpoints.xl}) {
    & {
      max-width: ${ContainerMaxWidth.xl};
    }
  }
`;
